<template>
  <div class="wrapper">
   <nav>
        <div class="container-landing">
            <div class="navbar">
                <div class="brand-link">
                    <a href="" class="navbar-brand">
                        <img src="../assets/images/pairboard-logo.svg" alt="" class="nav-logo">
                    </a>
                    <ul class="navbar-nav">
                        <li class="nav-item">
                            <a href="" class="nav-link"  style="visibility: hidden;">Home</a>
                        </li>
                        <li class="nav-item"  style="visibility: hidden;">
                            <a href="" class="nav-link">f</a>
                        </li>
                        <li class="nav-item"  style="visibility: hidden;">
                            <a href="" class="nav-link">Pricing</a>
                        </li>
                    </ul>
                </div>
                <div class="btn-desktop">
                    <div class="flex items-center gap-x-7">
                        <a href="/login" class="nav-link">Login</a>
                        <a href="/login" class="btn-start">Start for free</a>
                    </div>
                </div>
                <div class="hamburger" aria-label="Toggle navigation">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </div>
            <!-- Hamburger Menu -->
            <!-- Background Layer -->
            <div class="mobile-menu-layer"></div>
            <!-- Mobile Menu -->
            <div class="mobile-menu">
                <button class="close-menu" aria-label="Close menu">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M12.5 3.5L3.5 12.5" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M12.5 12.5L3.5 3.5" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </button>
                <ul>
                    <li><a href="#" class="nav-link">Home</a></li>
                    <li><a href="" class="nav-link" style="visibility: hidden;">Product</a></li>
                    <li><a href="" class="nav-link" style="visibility: hidden;">Pricing</a></li>
                    <li><a href="/login" class="nav-link">Login</a></li>
                    <li><a href="/login" class="btn-start">Start for free</a></li>
                </ul>
            </div>
        </div>
    </nav>
    <div class="container">
        <div class="login-box">
            <h3 class="login-header">Login to your Account</h3>
            <p class="login-description">Log in to stay organized and powered by AI.</p>
            <button @click.prevent="handleGoogleSignIn" class="gsi-material-button">
            <div class="gsi-material-button-state"></div>
            <div class="gsi-material-button-content-wrapper">
              <div class="gsi-material-button-icon">
                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" xmlns:xlink="http://www.w3.org/1999/xlink" style="display: block;">
                  <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"></path>
                  <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"></path>
                  <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"></path>
                  <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"></path>
                  <path fill="none" d="M0 0h48v48H0z"></path>
                </svg>
              </div>
              <span class="gsi-material-button-contents">Sign In with Google</span>
            </div>
            </button>
            <p class="explainer">Don't have an Account? <router-link to="signup">Sign Up</router-link></p>
        </div>
    </div>
  </div>

  </template>
  
  <script>
    export default {
      mounted() {
        const params = new URLSearchParams(window.location.search);
        const token = params.get('token');

        if (token) {
          console.log('Token found in URL:', token); // Debug log
          this.$store.dispatch('auth/handleLoginRedirect', token) // Dispatch token to Vuex
            .then(() => {
              console.log('Token saved, redirecting to dashboard'); // Debug log
              this.$router.push('/dashboard'); // Redirect to dashboard
            })
            .catch((err) => {
              console.error('Error handling login redirect:', err); // Debug log
            });
        } else if (this.$store.getters['auth/isAuthenticated']) {
          console.log('User already authenticated, redirecting to dashboard'); // Debug log
          this.$router.push('/dashboard'); // Redirect to dashboard
        } else {
          console.log('User not authenticated, staying on login page'); // Debug log
        }
      },
      methods: {
        handleGoogleSignIn() {
          const backendUrl = `${process.env.VUE_APP_BACKEND_URL}/auth/google`;
          window.location.href = backendUrl;
        },
      },
    };
  </script>
  
<style scoped>
    .login-header{
      font-family: 'Inter';
      font-style: normal;
      font-weight: 600;
      font-size: 28px;
      line-height: 24px;
      text-align: center;
      color: #E0E0E0;
    }
    .login-description{
    
      font-family: 'Inter';
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      text-align: center;
      color: #A0A0A0;
    }

    .explainer{
    /* Text sm/Medium */
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #A0A0A0;
    }
    .container {
    display: flex;
    justify-content: center; /* Center horizontally */
    align-items: center;    /* Center vertically */
    min-height: 100vh;      /* Full viewport height */
    margin: 0;              /* Remove default margin */
    }
    .wrapper{
      background: #121212;
    }

    /* Login box styling */
    .login-box {
    background: #1A1A1A;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
    text-align: center;
    width: 500px; /* Optional fixed width */
    border: 1px solid #2C2C2C;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
    }

    .gsi-material-button {
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -webkit-appearance: none;
  background-color: WHITE;
  background-image: none;
  border: 1px solid #747775;
  -webkit-border-radius: 20px;
  border-radius: 20px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #1f1f1f;
  cursor: pointer;
  font-family: 'Roboto', arial, sans-serif;
  font-size: 14px;
  height: 40px;
  letter-spacing: 0.25px;
  outline: none;
  overflow: hidden;
  padding: 0 12px;
  position: relative;
  text-align: center;
  -webkit-transition: background-color .218s, border-color .218s, box-shadow .218s;
  transition: background-color .218s, border-color .218s, box-shadow .218s;
  vertical-align: middle;
  white-space: nowrap;
  width: auto;
  max-width: 400px;
  min-width: min-content;
}

.gsi-material-button .gsi-material-button-icon {
  height: 20px;
  margin-right: 12px;
  min-width: 20px;
  width: 20px;
}

.gsi-material-button .gsi-material-button-content-wrapper {
  -webkit-align-items: center;
  align-items: center;
  display: flex;
  -webkit-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: nowrap;
  flex-wrap: nowrap;
  height: 100%;
  justify-content: space-between;
  position: relative;
  width: 100%;
}

.gsi-material-button .gsi-material-button-contents {
  -webkit-flex-grow: 1;
  flex-grow: 1;
  font-family: 'Roboto', arial, sans-serif;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: top;
}

.gsi-material-button .gsi-material-button-state {
  -webkit-transition: opacity .218s;
  transition: opacity .218s;
  bottom: 0;
  left: 0;
  opacity: 0;
  position: absolute;
  right: 0;
  top: 0;
}

.gsi-material-button:disabled {
  cursor: default;
  background-color: #ffffff61;
  border-color: #1f1f1f1f;
}

.gsi-material-button:disabled .gsi-material-button-contents {
  opacity: 38%;
}

.gsi-material-button:disabled .gsi-material-button-icon {
  opacity: 38%;
}

.gsi-material-button:not(:disabled):active .gsi-material-button-state, 
.gsi-material-button:not(:disabled):focus .gsi-material-button-state {
  background-color: #303030;
  opacity: 12%;
}

.gsi-material-button:not(:disabled):hover {
  -webkit-box-shadow: 0 1px 2px 0 rgba(60, 64, 67, .30), 0 1px 3px 1px rgba(60, 64, 67, .15);
  box-shadow: 0 1px 2px 0 rgba(60, 64, 67, .30), 0 1px 3px 1px rgba(60, 64, 67, .15);
}

.gsi-material-button:not(:disabled):hover .gsi-material-button-state {
  background-color: #303030;
  opacity: 8%;
}

</style>